<div class="container-fluid p-0 flex justify-center items-center" style="height: 100vh; overflow: auto;">
    <div class="text-center tis-section" *ngIf="errorMessage == ''">
        <img src="assets/logo/cantrack-logo-with-border.png" alt="logo2" class="img-fluid mb-3 m-auto" style="width: 70px;">
        <!-- <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="100" class="m-auto"></mat-progress-spinner> -->
        <p class="text-center mt-5"><i class="fas fa-spinner fa-spin"></i> Please wait while we are still processing ...</p>
    </div>
    <div class="tis-section" *ngIf="errorMessage != ''">
        <p class="text-center">{{ errorMessage }}</p>
    </div>
</div>